const { useI18n } = require('@fegobull/webapi').use;

const langTextMap = {
    0: {
        name: '名称',
        trend: '走势',
        increase: '涨幅',
        wch: '自选',
        add_selected_succ: '添加成功',
        del_selected_succ: '已从自选删除'
    },
    1: {
        name: '名稱',
        trend: '走勢',
        increase: '升幅',
        wch: '自選',
        add_selected_succ: '添加成功',
        del_selected_succ: '已從自選刪除'
    },
    2: {
        name: 'Name',
        trend: 'Trend',
        increase: '%Chg',
        wch: 'Watchlists',
        add_selected_succ: 'Added Successfully',
        del_selected_succ: 'Deleted'
    },
    5: {
        name: '銘柄',
        trend: 'チャート',
        increase: '变化',
        wch: 'お気に入り',
        add_selected_succ: '追加完了',
        del_selected_succ: 'お気に入りから削除されました'
    }
};

export { langTextMap, useI18n };
